import { Component, OnInit } from '@angular/core';
import { AuthService } from '../app/services/auth/auth.service';
import { PersistenceService, StorageType } from 'angular-persistence';
//
import { Constant } from '../app/infrastructure/constant';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { PageService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService, 
    private persistenceService: PersistenceService,
    private router: Router,
    private titleService : Title,
    private pageService:PageService) { }
  title = 'app';
  public hourLogin: number;
  public minuteLogin: number;
  ngOnInit() {
    var userId = this.persistenceService.get(Constant.auths.userId, StorageType.LOCAL);
   if(userId){
    var today = new Date();
    this.hourLogin = Number(today.getHours());
    this.minuteLogin = Number(today.getMinutes());
    this.authService.checkHourShift(userId, this.hourLogin, this.minuteLogin);
   } 
  //  this.checkRouting();
  }

  async checkRouting(){
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(async (event: NavigationEnd) => {
        let res = await this.pageService.getBypath(event.urlAfterRedirects);
        this.titleService.setTitle('POST('+res.data.name+')');
      });
  }
}
